export const TINYMCE_API_KEY =
  'r11m3u1asc12inb5bxptsi5otzpf9zgphu926c3ozvq6hpce';
export const TINYMCE_SCRIPT_SRC =
  'https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.1.2/tinymce.min.js';
